var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("Header"),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _c(
            "v-row",
            { staticClass: "ma-0 pa-0 pt-10" },
            [
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 mb-4",
                  attrs: { cols: "12", align: "left" },
                },
                [_vm._v(" " + _vm._s("장비 교체 시나리오") + " ")]
              ),
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 pt-2",
                  attrs: { cols: "6", align: "left" },
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0 pb-7" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { "align-self": "center" },
                        },
                        [_vm._v(" " + _vm._s("contractCd") + " ")]
                      ),
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0" },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.contractCdList,
                              "item-text": "contractCd",
                              "item-value": "contractCd",
                              dense: "",
                              "hide-details": "",
                              outlined: "",
                              dark: "",
                            },
                            model: {
                              value: _vm.contractCd,
                              callback: function ($$v) {
                                _vm.contractCd = $$v
                              },
                              expression: "contractCd",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0 pb-7" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { "align-self": "center" },
                        },
                        [_vm._v(" " + _vm._s("old Device SerialCd") + " ")]
                      ),
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0" },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.oldSerialCdList,
                              "item-text": "serialCd",
                              "item-value": "serialCd",
                              dense: "",
                              "hide-details": "",
                              outlined: "",
                              dark: "",
                            },
                            model: {
                              value: _vm.oldSerialCd,
                              callback: function ($$v) {
                                _vm.oldSerialCd = $$v
                              },
                              expression: "oldSerialCd",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0 pb-10" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { "align-self": "center" },
                        },
                        [_vm._v(" " + _vm._s("new Device SerialCd") + " ")]
                      ),
                      _c("v-col", { staticClass: "ma-0 pa-0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newSerialCd,
                              expression: "newSerialCd",
                            },
                          ],
                          attrs: {
                            id: "input_grey",
                            placeholder: "new device serial cd",
                          },
                          domProps: { value: _vm.newSerialCd },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.newSerialCd = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0 mt-7",
                      attrs: { justify: "space-around" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { id: "blue_btn" },
                          on: { click: _vm.deviceReplacement },
                        },
                        [_vm._v(_vm._s("1. 교체 요청"))]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { id: "blue_btn" },
                          on: { click: _vm.deviceInstall },
                        },
                        [_vm._v(_vm._s("2. 설치 완료"))]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { id: "blue_btn" },
                          on: { click: _vm.deviceComplete },
                        },
                        [_vm._v(_vm._s("3. 회수 완료"))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0 pl-10", attrs: { cols: "6" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0" },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0 pb-2",
                              attrs: { id: "text_big" },
                            },
                            [_vm._v(" " + _vm._s("old device") + " ")]
                          ),
                          _c("v-row", { staticClass: "ma-0 pa-0 pb-1" }, [
                            _vm._v(
                              " " +
                                _vm._s("serialCd : ") +
                                " " +
                                _vm._s(_vm.oldDeviceStatus.serialCd) +
                                " "
                            ),
                          ]),
                          _c("v-row", { staticClass: "ma-0 pa-0 pb-1" }, [
                            _vm._v(
                              " " +
                                _vm._s("deviceStatusCd : ") +
                                " " +
                                _vm._s(_vm.oldDeviceStatus.deviceStatusCd) +
                                " "
                            ),
                          ]),
                          _c("v-row", { staticClass: "ma-0 pa-0 pb-1" }, [
                            _vm._v(
                              " " +
                                _vm._s("deviceStatusName : ") +
                                " " +
                                _vm._s(_vm.oldDeviceStatus.deviceStatusName) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0 mt-10" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0" },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0 pb-2",
                              attrs: { id: "text_big" },
                            },
                            [_vm._v(" " + _vm._s("new device") + " ")]
                          ),
                          _c("v-row", { staticClass: "ma-0 pa-0 pb-1" }, [
                            _vm._v(
                              " " +
                                _vm._s("serialCd : ") +
                                " " +
                                _vm._s(_vm.newDeviceStatus.serialCd) +
                                " "
                            ),
                          ]),
                          _c("v-row", { staticClass: "ma-0 pa-0 pb-1" }, [
                            _vm._v(
                              " " +
                                _vm._s("deviceStatusCd : ") +
                                " " +
                                _vm._s(_vm.newDeviceStatus.deviceStatusCd) +
                                " "
                            ),
                          ]),
                          _c("v-row", { staticClass: "ma-0 pa-0 pb-1" }, [
                            _vm._v(
                              " " +
                                _vm._s("deviceStatusName : ") +
                                " " +
                                _vm._s(_vm.newDeviceStatus.deviceStatusName) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }